// extracted by mini-css-extract-plugin
export var dropDownMenu = "menu-page-module--dropDownMenu--98e76";
export var navbar = "menu-page-module--navbar--c5097";
export var open = "menu-page-module--open--6a4a5";